<template>
  <div class="container-fluid mol-typical-page-container-20">
    <h1 class="text-center logo-themed-header">
      <LogoSvg class="logo-icon" color="#e1bb28"></LogoSvg>
      <span class="text-my-oscar-list">MEMBERSHIP</span>
    </h1>

    <!-- show loading spinner if there's nothing else to show -->
    <LoadingSpinner v-if="isLoading"></LoadingSpinner>

    <section v-else>

      <div v-if="showWelcomeMessage" class="mol-color-theme-membership welcome-message">
        Welcome to Membership.
      </div>

      <!-- existing member -->
      <MembershipCard v-if="myMembership" :membership="myMembership" @membership-updated="getMyMembership"></MembershipCard>

      <!-- potential member -->
      <MembershipStorefront v-else></MembershipStorefront>
    </section>
  </div>

</template>


<script>
import LogoSvg from "@/components/icons/LogoSvg.vue";
import axios from "axios";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {userStore} from "@/userStore";
import MembershipCard from "@/components/membership/MembershipCard.vue";
import MembershipStorefront from "@/components/membership/MembershipStorefront.vue";


export default {
  name: "MembershipPage",
  computed: {
    userStore() {
      return userStore
    },
    stripeCheckoutSessionId() {
      return this.$route.query?.session_id;
    }
  },
  components: {
    MembershipStorefront,MembershipCard, LoadingSpinner, LogoSvg
  },
  data() {
    return {
      isLoading: true,
      myMembership: null,
      showWelcomeMessage: false
    }
  },
  async created() {

    try {
      this.isLoading = true;

      if ( this.stripeCheckoutSessionId ) {
        await this.resolveMemershipPurchase(this.stripeCheckoutSessionId);

        // if resolving the session purchase failed (maybe it's a bogus id, expired subscription or just not mine),
        //  then attempt to grab my own membership as if no session id were in the url.
        if ( !this.myMembership ) {
          await this.getMyMembership();
        }
      }
      else {
        await this.getMyMembership();
      }
    }
    catch (err) {
      console.log(err);
    }

    this.isLoading = false;
  },

  methods: {

    async getMyMembership() {
      return axios.get(`/api/membership/my-membership`,{
        validateStatus: status => status < 500 // we want to handle the 400s deliberately
      })
          .then(activeSubResponse => {
            //console.log(`GET /my-membership`, activeSubResponse);
            this.myMembership = (activeSubResponse.status < 300) ? activeSubResponse.data : null;
          });
    },

    async resolveMemershipPurchase(_sessionId) {

      return axios.post(`/api/membership/stripe/fulfill-purchase-from-session`, {
        session_id: _sessionId
      })
          .then(fulfillmentResponse => {
            //console.log(`GET /fulfill-purchase-from-session`, fulfillmentResponse);
            this.myMembership = (fulfillmentResponse.status < 300) ? fulfillmentResponse.data.new_subscription : null;

            if ( this.myMembership ) {
              this.showWelcomeMessage = true;

              if ( fulfillmentResponse.data.updatedUser ) {
                userStore.setUser(fulfillmentResponse.data.updatedUser);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
  }
}
</script>


<style scoped>

.logo-themed-header {
  color: var(--mol-color-gold);
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: xxx-large;

  svg {
    height: 1.125em;
    margin-right: 0.1em;
    margin-top: -0.1275em;
  }
}

.text-my-oscar-list {
  text-align: center;
  font-weight: 300;

  .text-oscar {
    font-weight: 600;
    padding-left: 0.05em;
    padding-right: 0.05em;
  }

  img {
    height: 1em;
    margin-right: 0.1em;
    margin-top: -0.2em;
  }
}

.welcome-message {
  margin-top: 2em;
  margin-bottom: 2em;
  text-align: center;

  font-size: larger;
  font-style: italic;
}


</style>